export const createRequestNumberGenerator = () => {
  let number = 0;
  let lastCompleted = 0;
  return {
    next() {
      number++;
      return number;
    },
    lastCompletedRequest() {
      return lastCompleted;
    },
    setLastCompletedRequest(request) {
      lastCompleted = request;
    }
  };
};